import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  ShoppingBag, 
  ShoppingCart, 
  Layers, 
  Image, 
  Ticket, 
  HelpCircle,
  LogOut,
  X
} from 'lucide-react';
import './Sidebar.css';
import Cookies from 'js-cookie';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove('auth_token');
    localStorage.clear();
    sessionStorage.clear();
    navigate('/', { replace: true });
  };

  const menuItems = [
    { name: 'Dashboard', icon: <LayoutDashboard size={20} />, path: '/dashboard' },
    { name: 'Products', icon: <ShoppingBag size={20} />, path: '/products' },
    { name: 'Orders', icon: <ShoppingCart size={20} />, path: '/orders' },
    { name: 'Categories', icon: <Layers size={20} />, path: '/categories' },
    { name: 'Banners', icon: <Image size={20} />, path: '/banners' },
    { name: 'Coupons', icon: <Ticket size={20} />, path: '/coupons' },
    { name: 'FAQs', icon: <HelpCircle size={20} />, path: '/faqs' },
  ];

  return (
    <aside className={`sidebar ${isOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-brand-group">
          <div className="logo-icon">C</div>
          <h2 className="brand-name">ANDLE CRAFT</h2>
        </div>
        {/* Mobile Close Button */}
        <button 
          type="button" 
          className="sidebar-close-btn" 
          onClick={onClose}
          aria-label="Close Sidebar"
        >
          <X size={20} />
        </button>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <NavLink 
            key={item.name} 
            to={item.path} 
            onClick={onClose}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-text">{item.name}</span>
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-footer">
        <button onClick={handleLogout} className="logout-btn">
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
